import { API } from 'aws-amplify';
import {statsColumns} from '../components/Common/enum';
import {
    FETCH_STATS_COLUMNS,
    FETCH_STATS,
    RULES_API_NAME,
    STATS_LOADING
} from './index';


export function fetchStatsColumns() {
    return {
        type: FETCH_STATS_COLUMNS,
        payload: statsColumns.filter(statColumn => {
            return statColumn.isVisible
        })
    }
}

export function receivedAllStats(stats) {
    return {
        type: FETCH_STATS,
        payload: stats
    }
}

export function statsIsLoading(isLoading){
    return {
        type: STATS_LOADING,
        payload: isLoading
    }
}

export function fetchStats() {

    let initParams = { 
        response: true 
    }
    let path = '/scanfilestats'; 


    return(dispatch) => {
        dispatch(statsIsLoading(true));
        return API.get(RULES_API_NAME, path, initParams)
            .then(response => {
                if(response.data) {
                    console.log('fetchStats data', response.data);
                    dispatch(receivedAllStats(response.data));
                } else {
                    console.log('No stats found.');
                }
            }).catch( e => {
                console.log('Error fetching stats');
                //alert('Error fetching stats');
            }).finally( e => {
                dispatch(statsIsLoading(false));
            });
    }
}


// WEBPACK FOOTER //
// ./src/actions/actions-stats.js